import PublicEditablePage from './PublicEditablePage';

const PrivacyPage = () => (
  <PublicEditablePage
    slug="privacy"
    fallbackTitle="Privacy Policy"
    seo={{
      title: 'Privacy Policy',
      description: 'How BlueSpark Australia collects, uses, and protects your personal information — Australian Privacy Principles compliant.',
      canonical: '/privacy',
    }}
  />
);

export default PrivacyPage;
